import {ComponentBoundary} from '../common/ComponentBoundary';
import {ComponentWithoutChildren} from '../react/types';
import {useCurrentUser} from './hooks/useCurrentUser';
import {UserAvatar} from './UserAvatar';

export const CurrentUserAvatar: ComponentWithoutChildren = () => {
  const currentUser = useCurrentUser();
  const {id} = currentUser.get();
  return (
    <ComponentBoundary>
      <UserAvatar id={id} />
    </ComponentBoundary>
  );
};
